import { render, staticRenderFns } from "./IconsPagesFinance.vue?vue&type=template&id=9ecdfa44&"
import script from "./IconsPagesFinance.vue?vue&type=script&lang=js&"
export * from "./IconsPagesFinance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports